import type { SlateBlock, SlateLeaf } from '@atlas/renderer';
import type { NodeMatch } from 'slate';

function _findNode<T extends SlateBlock | SlateLeaf>(
    nodes: Array<SlateBlock | SlateLeaf>,
    match: NodeMatch<T>,
    path: number[],
): [T, number[]] | undefined {
    let matched: [T, number[]] | undefined;
    nodes.find((node, index) => {
        const nodePath = path.concat(index);
        if (match(node, nodePath)) {
            matched = [node as T, nodePath];
            return true;
        }
        if ('children' in node) {
            matched = _findNode(node.children, match, nodePath);
            if (matched) return true;
        }
        return false;
    });
    return matched;
}

export default function findNode<T extends SlateBlock | SlateLeaf>(
    nodes: Array<SlateBlock | SlateLeaf>,
    match: NodeMatch<T>,
) {
    return _findNode(nodes, match, []);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('findNode', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
